export default {"src":"/_next/static/media/circle_arrow_right.f0e23d62.svg","height":25,"width":25};